import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ServerRackIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4.22222 11.8889H19.7778M4.22222 11.8889C3.63285 11.8889 3.06762 11.6548 2.65087 11.238C2.23413 10.8213 2 10.256 2 9.66667V5.22222C2 4.63285 2.23413 4.06762 2.65087 3.65087C3.06762 3.23413 3.63285 3 4.22222 3H19.7778C20.3671 3 20.9324 3.23413 21.3491 3.65087C21.7659 4.06762 22 4.63285 22 5.22222V9.66667C22 10.256 21.7659 10.8213 21.3491 11.238C20.9324 11.6548 20.3671 11.8889 19.7778 11.8889M4.22222 11.8889C3.63285 11.8889 3.06762 12.123 2.65087 12.5398C2.23413 12.9565 2 13.5217 2 14.1111V18.5556C2 19.1449 2.23413 19.7102 2.65087 20.1269C3.06762 20.5437 3.63285 20.7778 4.22222 20.7778H19.7778C20.3671 20.7778 20.9324 20.5437 21.3491 20.1269C21.7659 19.7102 22 19.1449 22 18.5556V14.1111C22 13.5217 21.7659 12.9565 21.3491 12.5398C20.9324 12.123 20.3671 11.8889 19.7778 11.8889M17.5556 7.44444H17.5667M17.5556 16.3333H17.5667"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

ServerRackIcon.displayName = 'ServerRackIcon';
